module.exports = __webpack_public_path__ + "static/media/8.8c8421ef.jpg";